import React from 'react';
const tomos = [{
  icon: '📘',
  title: 'MÓDULO 1 — Fundamentos Técnicos',
  desc: 'Principios del ciclo de refrigeración, componentes, herramientas y seguridad. Arrancás desde cero y llegás a base técnica real.'
}, {
  icon: '📗',
  title: 'MÓDULO 2 — Instalación Profesional',
  desc: 'Splits, heladeras y equipos de ventana. Medidas exactas, conexión eléctrica, carga de gas y puesta en marcha.'
}, {
  icon: '📙',
  title: 'MÓDULO 3 — Diagnóstico y Reparación',
  desc: 'Las 30 fallas más frecuentes resueltas paso a paso. Nunca más quedás trabado frente a un equipo que no enfría.'
}, {
  icon: '📕',
  title: 'MÓDULO 4 — Cobrar y Conseguir Clientes',
  desc: 'Presupuestos, precios, guiones para cerrar trabajos y cómo conseguir tus primeros clientes sin gastar en publicidad.'
}, {
  icon: '📔',
  title: 'MÓDULO 5 — Refrigeración Automotor',
  desc: 'Aires en autos, camiones y maquinaria pesada. Más servicios, más clientes, tickets más altos.'
}];
export function TomosDetail() {
  return <section className="py-12 md:py-16 px-4 bg-brand-navy" data-id="element-293">
      <div className="max-w-4xl mx-auto" data-id="element-294">
        <div className="text-center mb-8 md:mb-12" data-id="element-295">
          <h2 className="text-4xl font-black text-white mb-4" data-id="element-296">
            El contenido del Pack
          </h2>
          <div className="inline-block bg-brand-primary text-white font-bold px-6 py-2 rounded-lg text-xl shadow-md" data-id="element-297">
            ❄️ 5 Módulos Maestros
          </div>
        </div>

        <div className="space-y-6" data-id="element-298">
          {tomos.map((t, i) => <div key={i} className="bg-white/10 backdrop-blur-sm border border-white/10 p-6 md:p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow flex flex-col md:flex-row gap-6 items-start" data-id="element-299">
              <div className="text-5xl md:text-6xl flex-shrink-0 bg-brand-deep w-20 h-20 flex items-center justify-center rounded-2xl border border-white/10" data-id="element-300">
                {t.icon}
              </div>
              <div data-id="element-301">
                <h3 className="text-2xl font-black text-white mb-3" data-id="element-302">
                  {t.title}
                </h3>
                <p className="text-lg text-blue-100 leading-relaxed" data-id="element-303">
                  {t.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}